<ion-buttons>
  <ion-button (click)="dismiss()" size="large">
    <ion-icon name="close" slot="icon-only" color="light"></ion-icon>
  </ion-button>
</ion-buttons>
<div class="container-img">
  <img [src]="imagemAnimal" alt="imagem do animal" />
</div>
